// extracted by mini-css-extract-plugin
module.exports = {"container":"TheHeader_container_3nwNk","logo":"TheHeader_logo_2frZF","subtitle":"TheHeader_subtitle_3R2GO"};